import { Alert } from 'antd'
import dayjs from 'dayjs'

export function OrderArchiveNotice({ archivedAt }: { archivedAt: Date | null }) {
  if (!archivedAt) return null
  return (
    <Alert
      className="mt-4!"
      showIcon
      type="info"
      title={`订单已归档 · ${dayjs(archivedAt).format('YYYY-MM-DD HH:mm')}`}
      description="订单已移出默认的未归档列表，原业务状态保留。历史合同、账单和未结款项继续保留，可查询账单、处理收退款及补充备注附件；在列表将“归档状态”切换为“已归档”或“全部”即可查看。"
    />
  )
}
